
import {
  CREATE_COMPANY_SUCCESS,
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_FAIL,
  CREATE_COMPANY,
  CREATE_COMPANY_FAIL,
  GET_COMPANY,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_FAIL,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  DELETE_COMPANY,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL,
  UPDATE_COMPANY_FAIL,
  CLEAR_ERRORS,
  GET_COMPANIES_ALL_FAIL,
  GET_COMPANIES_ALL_SUCCESS,
  GET_COMPANIES_ALL
} from "./actionTypes";

export const getCompanies = params => ({
  type: GET_COMPANIES,
  payload: params,
})

export const getCompaniesSuccess = data => ({
  type: GET_COMPANIES_SUCCESS,
  payload: data,
})

export const getCompaniesFail = error => ({
  type: GET_COMPANIES_FAIL,
  payload: error,
})

export const getCompaniesAll = params => ({
  type: GET_COMPANIES_ALL,
  payload: params,
})

export const getCompaniesAllSuccess = data => ({
  type: GET_COMPANIES_ALL_SUCCESS,
  payload: data,
})

export const getCompaniesAllFail = error => ({
  type: GET_COMPANIES_ALL_FAIL,
  payload: error,
})

export const createCompany = (data, history, getCompanies) => ({
  type: CREATE_COMPANY,
  payload: { data, history, getCompanies },
})

export const createCompanySuccess = data => ({
  type: CREATE_COMPANY_SUCCESS,
  payload: data,
})

export const createCompanyFail = error => ({
  type: CREATE_COMPANY_FAIL,
  payload: error,
})

export const getCompany = companyId => ({
  type: GET_COMPANY,
  payload: { companyId },
})

export const getCompanySuccess = data => ({
  type: GET_COMPANY_SUCCESS,
  payload: data,
})

export const getCompanyFail = error => ({
  type: GET_COMPANY_FAIL,
  payload: error,
})

export const updateCompany = (data, history, getCompanies, companyId) => ({
  type: UPDATE_COMPANY,
  payload: { data, history, getCompanies, companyId },
})

export const updateCompanySuccess = data => ({
  type: UPDATE_COMPANY_SUCCESS,
  payload: data,
})

export const updateCompanyFail = error => ({
  type: UPDATE_COMPANY_FAIL,
  payload: error,
})

export const deleteCompany = (history, getCompanies, companyId) => ({
  type: DELETE_COMPANY,
  payload: { history, getCompanies, companyId },
})

export const deleteCompanySuccess = data => ({
  type: DELETE_COMPANY_SUCCESS,
  payload: data,
})

export const deleteCompanyFail = error => ({
  type: DELETE_COMPANY_FAIL,
  payload: error,
})

export const clearCompanyErrors = data => ({
  type: CLEAR_ERRORS,
})

